import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCogs = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#b3e1e0",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M8 12.6667V7.06665",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.13333 8.93332L8 7.06665L9.86666 8.93332",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.93333 4.73334H14.0667C14.0667 4.73334 15 4.73334 15 5.66667V14.0667C15 14.0667 15 15 14.0667 15H1.93333C1.93333 15 1 15 1 14.0667V5.66667C1 5.66667 1 4.73334 1.93333 4.73334Z",
			fill: "currentColor",
			fillOpacity: .25,
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.12566 5.19938L2.619 1.55378C2.69249 1.38867 2.81234 1.24845 2.964 1.15015C3.11565 1.05184 3.29258 0.999684 3.47331 1H12.5266C12.7072 0.999979 12.8839 1.05234 13.0354 1.15075C13.1868 1.24915 13.3064 1.38937 13.3797 1.5544L14.8376 5.14151",
			fill: "currentColor",
			fillOpacity: .25
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.12566 5.19938L2.619 1.55378C2.69249 1.38867 2.81234 1.24845 2.964 1.15015C3.11565 1.05184 3.29258 0.999684 3.47331 1H12.5266C12.7072 0.999979 12.8839 1.05234 13.0354 1.15075C13.1868 1.24915 13.3064 1.38937 13.3797 1.5544L14.8376 5.14151",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8 4.73333V1",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgCogs;
